'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import 'lodash.isempty';
import '../../constants/global.mjs';
import '../../utils/env.mjs';
import IcClose from '../icons/IcClose.mjs';
import styles from './ModalFrame.module.scss.mjs';

const cx = classNames.bind(styles);
function ModalCloseButton(_ref) {
  let {
    closeButtonText,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-close'),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IcClose, {
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, closeButtonText, "\uBAA8\uB2EC \uB2EB\uAE30"));
}
/**
 * showCloseButton: Pie > HalfLayerWrapper props 명 참고했습니다. X button 노출/미노출
 * closeButtonText: (선택) 접근성 개선사항 -> 닫기버튼에 명확한 모달명을 추가로 전달합니다.
 * role: (선택)) 접근성 개선사항 -> 모달 역할을 추가로 전달합니다.
 *       dialog: 중요정보 및 사용자 인터랙션 필요한 경우 | alertdialog: 간단한정보 및 인터랙션(yes or no)
 */
const ModalFrame = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    direction,
    isShow,
    isShowCloseButton,
    children,
    closeButtonText,
    onClickCloseButton,
    close,
    customClassName,
    role,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', customClassName, {
      [`type-${direction}`]: direction,
      animation: isShow
    }),
    role: role,
    ref: ref,
    ...props
  }, children, isShowCloseButton && ( /*#__PURE__*/React.createElement(ModalCloseButton, {
    closeButtonText: closeButtonText,
    onClick: onClickCloseButton ?? close
  })));
});

export { ModalCloseButton, ModalFrame as default };
